import api from './apiClient';

/** One data source's age (GET /api/freshness, public). */
export interface SourceFreshness {
  key: 'tender' | 'bid' | 'shilendans' | 'legal_entity' | 'xacxom' | string;
  name: string;
  site: string;
  rows: number;
  /** when rows last arrived (ISO), null if the table is empty */
  as_of: string | null;
  stale_after_days: number;
  /** ok · stale (older than stale_after_days) · failing (the latest fetch failed) */
  status: 'ok' | 'stale' | 'failing';
  reason: string | null;
  last_attempt: string | null;
}

export interface Freshness {
  checked_at: string;
  sources: SourceFreshness[];
  /** the landing page's numbers, for visitors who are not logged in */
  summary: { total_tenders: number; total_organizations: number; total_bidders: number; total_budget: number } | null;
}

export const freshnessApi = {
  async get(): Promise<Freshness> {
    const { data } = await api.get<Freshness>('/freshness');
    return data;
  },
};
